import React from 'react';

import InfoMessage from '@eika/attention-message/lib/InfoMessage';
import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { RadioButtonPanels } from '@eika/radio-button';

import { ReorderInfo, SiteCoreDictionary } from '../types';
import { booleanOrUndefinedValueToReorderValue, getReorderOptions, reorderValueToBooleanValue } from './functions';

import './Form.scss';

interface FormProps {
    selectedReorderError: string | undefined;
    dictionary: SiteCoreDictionary;
    reorderInfo: ReorderInfo | undefined;
    userIsHighFraudRisk?: boolean;
    priceListUrl?: string | undefined;
}

const Form = ({ reorderInfo, selectedReorderError, dictionary, userIsHighFraudRisk, priceListUrl }: FormProps) => {
    const { reorderingNotAvailableMessage } = dictionary;

    if (typeof reorderInfo === 'undefined') {
        return null;
    }

    const REORDER_OPTIONS = getReorderOptions(dictionary, userIsHighFraudRisk);

    const { selectedReorder, setSelectedReorder } = reorderInfo;

    const goToUrl = (url: string) => {
        window.location.href = url;
    };

    return (
        <div className="reorder-container">
            {priceListUrl && (
                <LinkButton
                    className="price-list-link"
                    onClick={() => goToUrl(priceListUrl)}
                    icon={IconTypes.EKSTERN_24}
                    iconOnRightSide
                >
                    {dictionary.blockPriceListLink}
                </LinkButton>
            )}
            <RadioButtonPanels
                label=""
                name="vil-du-bestille-nytt-kort"
                onChange={(value) => setSelectedReorder(reorderValueToBooleanValue(value))}
                selectedOption={booleanOrUndefinedValueToReorderValue(selectedReorder, REORDER_OPTIONS)}
                options={REORDER_OPTIONS}
                errorMessage={selectedReorderError}
            />
            {userIsHighFraudRisk && (
                <InfoMessage
                    className="info-message-not-available"
                    type="attention"
                    text={reorderingNotAvailableMessage}
                />
            )}
        </div>
    );
};

export default Form;
